import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIteoLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 196 58",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	x: "0px",
	y: "0px",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2.07603 20.5697L2.26656 20.646L8.97026 27.3497C9.02107 27.4322 9.01472 27.518 9.01155 27.6101C9.00837 28.2706 8.74163 29.2392 8.70352 29.9759C8.15414 41.0492 17.7413 50.1982 28.7765 49.2042C41.3329 48.0705 49.2084 34.8505 43.9909 23.2595C43.8543 22.9578 43.1208 21.4557 42.9524 21.3255C42.9016 21.2874 42.8858 21.2461 42.8064 21.262C42.7524 21.2716 42.0696 21.7987 41.914 21.8971C33.5368 27.1369 23.3653 27.8038 14.5943 23.0213C10.8661 20.9889 7.9509 18.0737 5.12778 14.9838C7.86833 12.021 10.593 9.24235 14.137 7.22901C32.8762 -3.40928 55.855 11.6526 54.1878 32.9451C52.2856 57.2512 21.4853 66.7907 6.03918 47.7942C-0.146903 40.1855 -1.58545 29.671 2.07603 20.5697ZM17.9985 14.9362C22.6 18.0674 28.7924 18.3341 33.921 16.343C34.2449 16.216 36.471 15.2188 36.5123 15.0474C36.5409 14.9299 36.4107 14.8918 36.3377 14.8441C35.3151 14.1804 33.5622 13.5072 32.3809 13.1642C27.4936 11.7447 22.3713 12.3671 17.9985 14.9362Z",
			fill: "#FF6500"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M52.4651 0.755305L46.6758 6.55273L52.7069 12.5754L58.4962 6.778L52.4651 0.755305Z",
			fill: "#FF6500"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M152.931 36.641H127.866C128.295 40.0135 130.498 42.7413 133.884 43.459C137.269 44.1767 140.921 43.1192 142.836 40.1468H152.321C150.349 45.8883 145.446 50.204 139.447 51.3059C126.132 53.748 116.075 42.1602 119.368 29.2577C123.515 13.0113 147.018 12.2301 152.204 28.0414C153.102 30.7788 153.344 33.7956 152.931 36.6441V36.641ZM144.166 30.5501C143.334 27.4857 141.092 25.069 137.92 24.418C133.296 23.4685 129.136 25.9328 128.088 30.5501H144.163H144.166Z",
			fill: "#FF6500"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M104.55 10.0645V18.2893H113.159V25.1422H104.665L104.547 25.4058C104.738 29.9469 104.309 34.6754 104.547 39.1975C104.643 41.0076 105.173 42.697 106.913 43.5354C107.231 43.6878 108.234 44.0308 108.549 44.0308H113.312V51.6459C108.828 51.503 103.861 52.3794 100.063 49.4674C97.5577 47.5462 96.3478 44.7421 96.0938 41.63V25.4058L95.9795 25.1422H90.3809V18.2893H96.0938V10.0645H104.55Z",
			fill: "#FF6500"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.9977 21.7168H73.4648V51.6469H81.9977V21.7168Z",
			fill: "#FF6500"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.9977 10.0654H73.4648V18.214H81.9977V10.0654Z",
			fill: "#FF6500"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M176.077 16.6332C188.776 15.9441 198.062 26.9793 194.397 39.3642C189.507 55.8964 164.286 55.6265 159.885 38.9418C156.896 27.6144 164.429 17.2651 176.077 16.6332ZM176.611 25.0104C165.048 25.7186 165.563 44.0863 178.186 43.1876C182.104 42.9082 185.223 39.939 185.896 36.1187C186.979 29.993 183.07 24.6135 176.611 25.0073V25.0104Z",
			fill: "#FF6500"
		})
	]
});
export default SvgIteoLogo;
